// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

export const InputServicePullDown = (props: {
  plan_label: string;
  plans: {
    id: number;
    service_name: string;
    value: number;
    tax: number;
  }[];
  selectPullDownPlan: string;
  setSelectPullDownPlan: (value: string) => void;
  service_required_optional_pull_down: string;
  service_trial_period_months: string;
}) => {
  const {
    plan_label,
    plans,
    selectPullDownPlan,
    setSelectPullDownPlan,
    service_required_optional_pull_down,
    service_trial_period_months,
  } = props;
  return (
    <>
      <div className="input_block">
        <label style={{ margin: "0px" }}>
          {plan_label + service_trial_period_months}
          {service_required_optional_pull_down === "必須" ? (
            <span className="require">必須</span>
          ) : null}
        </label>
      </div>
      {service_required_optional_pull_down !== "必須" ? (
        <div className="checkbox_block">
          <span className="wpcf7-form-control-wrap" data-name="checkbox-664">
            <span className="wpcf7-form-control wpcf7-acceptance">
              <span className="wpcf7-list-item">
                <label>
                  <input
                    type="radio"
                    style={{ width: "inherit" }}
                    checked={"特に選択しない" === selectPullDownPlan}
                    onClick={() => {
                      setSelectPullDownPlan("特に選択しない");
                    }}
                  />
                  <span className="wpcf7-list-item-label">
                    {"特に選択しない"}
                  </span>
                </label>
              </span>
            </span>
          </span>
        </div>
      ) : null}
      {plans.map((plan) => {
        return (
          <div className="checkbox_block">
            <span className="wpcf7-form-control-wrap" data-name="checkbox-664">
              <span className="wpcf7-form-control wpcf7-acceptance">
                <span className="wpcf7-list-item">
                  <label>
                    <input
                      type="radio"
                      style={{ width: "inherit" }}
                      checked={plan.service_name === selectPullDownPlan}
                      onClick={() => {
                        setSelectPullDownPlan(plan.service_name);
                      }}
                    />
                    <span className="wpcf7-list-item-label">
                      {plan.value === 0 && plan.tax === 0
                        ? plan.service_name
                        : plan.service_name +
                          " (" +
                          "月額" +
                          (plan.value + plan.tax) +
                          "円[税込])"}
                    </span>
                  </label>
                </span>
              </span>
            </span>
          </div>
        );
      })}
    </>
  );
};

export const InputServiceCheckBox = (props: {
  plan_label: string;
  plans: {
    id: number;
    service_name: string;
    value: number;
    tax: number;
  }[];
  selectCheckBoxPlans: string[];
  setSelectCheckBoxPlans: (value: string[]) => void;
  service_required_optional_check_box: string;
  service_trial_period_months: string;
}) => {
  const {
    plan_label,
    plans,
    selectCheckBoxPlans,
    setSelectCheckBoxPlans,
    service_required_optional_check_box,
    service_trial_period_months,
  } = props;
  return (
    <>
      <div className="input_block">
        <label style={{ margin: "0px" }}>
          {plan_label + service_trial_period_months}
          {service_required_optional_check_box === "必須" ? (
            <span className="require">必須</span>
          ) : null}
        </label>
      </div>
      {plans.map((plan) => {
        return (
          <div className="checkbox_block">
            <span className="wpcf7-form-control-wrap" data-name="checkbox-664">
              <span className="wpcf7-form-control wpcf7-acceptance">
                <span className="wpcf7-list-item">
                  <label>
                    <input
                      type="checkbox"
                      checked={selectCheckBoxPlans.includes(plan.service_name)}
                      style={{ width: "inherit" }}
                      onClick={() => {
                        let _selectCheckBoxPlans = selectCheckBoxPlans.concat();
                        if (selectCheckBoxPlans.includes(plan.service_name)) {
                          _selectCheckBoxPlans = _selectCheckBoxPlans.filter(
                            (service_name) => service_name !== plan.service_name
                          );
                        } else {
                          _selectCheckBoxPlans.push(plan.service_name);
                        }
                        setSelectCheckBoxPlans(_selectCheckBoxPlans);
                      }}
                    />
                    <span className="wpcf7-list-item-label">
                      {plan.value === 0 && plan.tax === 0
                        ? plan.service_name
                        : plan.service_name +
                          " (" +
                          "月額" +
                          (plan.value + plan.tax) +
                          "円[税込])"}
                    </span>
                  </label>
                </span>
              </span>
            </span>
          </div>
        );
      })}
    </>
  );
};

export const InputPaymentCheckBox = (props: {
  paymentMethod: { type: string; name: string }[];
  selectPaymentMethod: string;
  setSelectPaymentMethod: (value: string) => void;
}) => {
  const { paymentMethod, selectPaymentMethod, setSelectPaymentMethod } = props;
  const layoutConfig = useAtomValue(AppAtoms.layoutConfig);
  return (
    <>
      <div className="input_block">
        <label style={{ margin: "0px" }}>
          支払方法<span className="require">必須</span>
        </label>
      </div>
      {paymentMethod.map((payment) => {
        if (
          (layoutConfig.trial_period_months ===
            "特に表示なし（登録月から課金開始）" &&
            payment.type !== "sbpayment-softbank" &&
            payment.type !== "sbpayment-kddi") ||
          layoutConfig.trial_period_months !==
            "特に表示なし（登録月から課金開始）"
        )
          return (
            <div className="checkbox_block">
              <span
                className="wpcf7-form-control-wrap"
                data-name="checkbox-664"
              >
                <span className="wpcf7-form-control wpcf7-acceptance">
                  <span className="wpcf7-list-item">
                    <label>
                      <input
                        type="radio"
                        checked={payment.type == selectPaymentMethod}
                        style={{ width: "inherit" }}
                        onClick={() => {
                          setSelectPaymentMethod(payment.type);
                        }}
                      />
                      <span className="wpcf7-list-item-label">
                        {payment.name}
                      </span>
                    </label>
                  </span>
                </span>
              </span>
            </div>
          );
      })}
    </>
  );
};

export const AgreePdfCheckBox = (props: {
  file_path: string;
  file_name: string;
  checkPDF: string[];
  setCheckPDF: (value: string[]) => void;
}) => {
  const { file_path, file_name, checkPDF, setCheckPDF } = props;
  return (
    <div className="checkbox_block">
      <span className="wpcf7-form-control-wrap" data-name="acceptance-989">
        <span className="wpcf7-form-control wpcf7-acceptance">
          <span className="wpcf7-list-item">
            <label>
              <input
                checked={checkPDF.includes(file_path)}
                type="checkbox"
                onClick={() => {
                  let _checkPDF = checkPDF.concat();
                  if (checkPDF.includes(file_path)) {
                    _checkPDF = _checkPDF.filter(
                      (_file_path) => _file_path !== file_path
                    );
                  } else {
                    _checkPDF.push(file_path);
                  }
                  setCheckPDF(_checkPDF);
                }}
              />
              <span className="wpcf7-list-item-label">
                <a href={file_path} target="_blank" rel="noopener noreferrer">
                  「{file_name}」
                </a>
                に同意する
              </span>
            </label>
          </span>
        </span>
      </span>
    </div>
  );
};
